import { SorterResult } from 'antd/lib/table/interface';
import React, { FC } from 'react';
import { CsatRating } from 'api/reports/csat';
import { Table } from './styles';

interface HeaderProps {
  columns: any[];
  onChange: (sorter: SorterResult<CsatRating>) => void;
}

export const Header: FC<HeaderProps> = ({ columns, onChange }) => (
  <Table
    size="small"
    dataSource={[]}
    showHeader
    pagination={false}
    columns={columns}
    tableLayout="fixed"
    onChange={(pagination, filters, sorter) =>
      onChange(sorter as SorterResult<CsatRating>)
    }
  />
);
